export default __webpack_public_path__ + "static/media/bannerCrisBarrosMobileOptimized.16ba75ff.svg";